import { BannerMediaTypes, MediaType } from './mediatype.enum';

export enum BannerType {
    MOON = 'moon',
    PORTRAIT_LARGE = 'portrait_large',
    LANDSCAPE_TOP_PANEL = 'landscape_top_panel',
    LANDSCAPE_SPEECH_BUBBLE = 'landscape_speech_bubble',
    ONBOARDING_SPEECH_BUBBLE = 'onboarding_speech_bubble',
    LANDSCAPE_WITH_BUTTON = 'landscape_with_button',
    LANDSCAPE_WIDE = 'landscape_wide',
    RECTANGULAR_MEDIUM = 'rectangular_medium',
}

export enum BannerActionType {
    OPEN_PDP = 'open_pdp',
    OPEN_SHOP = 'open_shop',
    OPEN_SCENE = 'open_scene',
    OPEN_TAB = 'open_tab',
    OPEN_DISTRICT = 'open_district',
}

export enum BannerPositionScene {
    START_SCREEN = 'start_screen',
    HD_CATALOG = 'hd_catalog',
    HD_BUILDING_SELECT = 'hd_building_select',
    OD_CATALOG = 'od_catalog',
    CC_CATALOG = 'cc_catalog',
    CC_CHARACTER_SELECT = 'cc_character_select',
    WORLD_MAP = 'world_map',
}

export enum BannerPositionPlacement {
    TOP_LEFT = 'top_left',
    TOP_RIGHT = 'top_right',
    SCENE_SPECIFIC = 'scene_specific',
    FIRST_SELECT_ITEM = 'first_select_item',
    LAST_SELECT_ITEM = 'last_select_item',
    BUTTON_RIGHT = 'button_right',
}

export enum BannerStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    DEFAULT = 'default',
}

export const PossiblePlacementByScene = {
    [BannerPositionScene.START_SCREEN]: [BannerPositionPlacement.TOP_LEFT],
    [BannerPositionScene.WORLD_MAP]: [
        BannerPositionPlacement.TOP_LEFT,
        BannerPositionPlacement.TOP_RIGHT,
    ],
    [BannerPositionScene.HD_BUILDING_SELECT]: [
        BannerPositionPlacement.FIRST_SELECT_ITEM,
        BannerPositionPlacement.LAST_SELECT_ITEM,
    ],
    [BannerPositionScene.HD_CATALOG]: [BannerPositionPlacement.SCENE_SPECIFIC],
    [BannerPositionScene.CC_CHARACTER_SELECT]: [
        BannerPositionPlacement.FIRST_SELECT_ITEM,
        BannerPositionPlacement.LAST_SELECT_ITEM,
    ],
    [BannerPositionScene.CC_CATALOG]: [BannerPositionPlacement.SCENE_SPECIFIC],
    [BannerPositionScene.OD_CATALOG]: [BannerPositionPlacement.BUTTON_RIGHT],
};

export const BannerBackgroundTypeByBannerType: Record<
    BannerType,
    BannerMediaTypes
> = {
    [BannerType.MOON]: MediaType.BANNER_MOON_BACKGROUND,
    [BannerType.RECTANGULAR_MEDIUM]:
        MediaType.BANNER_RECTANGULAR_MEDIUM_BACKGROUND,
    [BannerType.LANDSCAPE_WIDE]: MediaType.BANNER_LANDSCAPE_WIDE_BACKGROUND,
    [BannerType.PORTRAIT_LARGE]: MediaType.BANNER_PORTRAIT_LARGE_BACKGROUND,
    [BannerType.LANDSCAPE_TOP_PANEL]:
        MediaType.BANNER_LANDSCAPE_TOP_PANEL_BACKGROUND,
    [BannerType.LANDSCAPE_SPEECH_BUBBLE]:
        MediaType.BANNER_LANDSCAPE_SPEECH_BUBBLE_BACKGROUND,
    [BannerType.ONBOARDING_SPEECH_BUBBLE]:
        MediaType.BANNER_LANDSCAPE_SPEECH_BUBBLE_BACKGROUND,
    [BannerType.LANDSCAPE_WITH_BUTTON]:
        MediaType.BANNER_LANDSCAPE_WITH_BUTTON_BACKGROUND,
};

export const BannerSceneDisplayName = {
    [BannerPositionScene.START_SCREEN]: 'Start Screen',
    [BannerPositionScene.WORLD_MAP]: 'World Map',
    [BannerPositionScene.HD_BUILDING_SELECT]: 'HD Build menu',
    [BannerPositionScene.HD_CATALOG]: 'HD Inventory',
    [BannerPositionScene.CC_CHARACTER_SELECT]: 'CC Exterior',
    [BannerPositionScene.CC_CATALOG]: 'CC Interior',
    [BannerPositionScene.OD_CATALOG]: 'OD Interior',
};
